
export type RootState = {
  login: LoginState;
  users: UserState;
  propsals: ProposalState;
};

export type ProposalState = {
  allocationData: {
    loading: boolean;
    data: any;
  };
  allocationFile: {
    loading: boolean;
    done: boolean;
    data: any;
  };
  uploadProposal: {
    loading: boolean;
    done: boolean;
    data: any;
  };
};

export type UserState = {
  usersData: {
    loading: boolean;
    data: any;
  };
  userTemplate: {
    loading: boolean;
    data: any;
  };
  userReport: {
    loading: boolean;
    data: any;
  };
  userUpload: {
    loading: boolean;
    data: any;
  };
  userDataTable: {
    data: any;
    loading: boolean;
  };
  userSearchFilters: {
    data: any;
    loading: boolean;
  };
  userEditForm: {
    data: any;
    loading: boolean;
  };
  userViewForm: {
    data: any;
    loading: boolean;
  };
  userViewData: {
    data: any;
    loading: boolean;
  };
  userDataSave: {
    data: any;
    loading: boolean;
  };
  createNewRecord: {
    data: any;
    loading: boolean;
  };
  deleteRecordData: {
    data: any;
    loading: boolean;
  };
  userProfileUpload: {
    data: null,
    loading: false,
  },
  externalUserInfo: {
    data: null,
  }
};

export type LoginState = {
  login: {
    loading: boolean;
    data: any;
  };
  logout: {
    loading: boolean;
    data: any;
  };
  deviceManagement: {
    data: any;
    loading: boolean;
  };
};

export type TripState = {
  tripDetails: {
    loading: boolean;
    data: any;
  };
  deviceUserMapping: {
    loading: boolean;
    data: any;
  };
  deviceUsers: {
    loading: boolean;
    data: any;
  };
  stompClient: {
    ref: any;
  };
};

export type User = {
  name: string;
  ecode: string;
  userId: string;
  email: string;
};

export type GeocoordinateEntry = {
  latitude: number;
  longitude: number;
  submissionDtm: number;
};


export enum AccessLevel {
  NONE = "None",
  READ = "Read",
  CREATE = "Read, Create",
  EDIT = "Read, Create, Edit",
  DELETE = "Read, Create, Edit, Delete",
  TRANSFER = "Read, Create, Edit, Delete, Transfer"
}

export type StepDetailProps = {
  screens: StepScreen[];
  showSummary?: boolean;
  onSubmit?: string;
}


export type StepScreen = {
  title?: string;
  blueprintApi?: string;
  onNext?: string;
}

export enum StepAction {
  BACK = "BACK",
  NEXT = "NEXT",
  SUBMIT = "SUBMIT"
}

export type DenominationOptionValues = {
  value: number;
  times?: number;
}

export enum RowLevelAction {
  VIEW = "View",
  CREATE = "Create",
  EDIT = "Edit",
  TRANSFER = "Transfer",
  CREATEWITHCONTEXT = "CreateWithContext"
}

export type ExtraRecordLevelActions = {
  actionName: string,
  actionType: string,
  action?: RowLevelAction,
  performFormValidation?: boolean,
  usePlatformCallback?: boolean,
  method: string,
  args: any[],
  visibilityCriteria: ActionVisibilityCriteria,
  blueprintApi?: string,
  launchMode?: string
}

export type ActionVisibilityCriteria = {
  "computationType": string,
  "method"?: string,
  "args"?: [],
  "expr"?: string,
}

export type ReportingToUser = {
  ecode: string;
  name?: string;
  roleCode?: string;
  roleName?: string;
}

export type platformActionLabelsType = {
  actionName: string,
  label: string,
  visibilityCriteria?: ActionVisibilityCriteria
}

export type AccessInfo = {
  moduleCode: string;
  accessLevel: AccessLevel;
}

export type ProfileInfo = {
  profileCode?: string;
  profileName?: string;
  description?: string;
  accessInfo?: Array<AccessInfo>;
}

export type ProfileDisplayMenuSection = {
  mainMenuName: string;
  mainMenuCode: string;
  modules: Array<ModuleInfo>;
  icon? : string;
}

export type ModuleInfo = {
  moduleCode: string;
  moduleName?: string;
}

export type SubMenuLink = {
  subMenuCode: string;
  subMenuName: string;
  url?: string;
  layoutType?: string;
  moduleCode?: string;
  moduleName?: string;
  accessLevel?: AccessLevel
  dataTableBluePrintUrl?: string;
  searchBluePrintUrl?: string;
  order?:number;
  webView?:boolean;
}

export type MenuLink = {
  mainMenuCode: string;
  mainMenuName: string;
  icon?: string;
  subMenuList: Array<SubMenuLink>;
}

export type DataTableHighlightSection = {
  type?: string,
  api?: string,
  apiKey?: string,
  uniqueName?: string,
  defaultValue?: string,
  label: string
}

export type UserModulesAccessState = {
  menuLinks: {
    loading: boolean;
    data: Array<MenuLink>;
  };
};

export type sectionField = {
  field: string;
  displayName: string;
  type?: string;
  imageList?: boolean;
  mainCardBoard?: boolean;
  mobileCopyIcon?:boolean;
  mapIcon?:boolean;
  evalFormula?:string;
}

//Not expoted as it is only used in section and sub section types below
type sectionTemplate = {
  headingColor?: string;
  labelColor?: string;
  dataColor?: string;
  order?: number;
}

export type subSectionInfo = {
  title: string;
  viewForm?: sectionField[];
  template?:sectionTemplate
}

export type section = {
  api: string;
  viewForm?: sectionField[];
  subsections?: subSectionInfo[];
  sectionName: string;
  columns?: number;
  expand?: boolean;
  template?: sectionTemplate;
  popOverBoard?:boolean; 
  isPinned?:boolean;
}


export type sectionWithTitle = {
  formFields?: sectionField[];
  sectionName: string;
  sectionFieldValues: Array<any>;
  columns?: number;
  skipHeader?: boolean;
}


export type Address = {
  loanNo: string,
  city: string,
  addressType: string,
  pinCode: string,
  masterAddLine1: string,
  addressLine1: string,
  masterAddLine2: string,
  addressLine2: string,
  addressLine3: string,
  state: string,
  latitude: number,
  longitude: number,
  addressFrom?: string,
}